// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IVcg","question":"styles_question__1DnpP","description":"styles_description__2sRff"};